import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ListGroupSettingModel, SettingModel } from '../model/setting.model';
import { headersBase } from '../../../../helper/headerBase';

@Injectable()
export class SettingServiceRest {

  constructor(
    private http: HttpClient
  ) { }

  public getSetting(param: string): Observable<ListGroupSettingModel[]> {
    return this.http.get<ListGroupSettingModel[]>(`/setting`, headersBase());
  }

  public setSetting(model: SettingModel): Observable<SettingModel> {
    return this.http.put<SettingModel>(`/setting`, model, headersBase());
  }
}

